import { render, staticRenderFns } from "./waterPipe.vue?vue&type=template&id=2c490344&scoped=true"
import script from "./waterPipe.vue?vue&type=script&lang=js"
export * from "./waterPipe.vue?vue&type=script&lang=js"
import style0 from "./waterPipe.vue?vue&type=style&index=0&id=2c490344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c490344",
  null
  
)

export default component.exports